module.exports = __webpack_public_path__ + "img/ico-instagram.61cecf43.svg";